import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { NUC_FULL_MODAL_SCROLL_STRATEGY_PROVIDER } from '@relayter/rubber-duck';
import { relayterApiInterceptorFn } from './app/api/authentication.intercepter';
import { AppComponent } from './app/app.component';
import { OVERMIND_DATE_FORMATS } from './app/pipes/date.pipe';
import { ROUTES } from './app/router/router';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(MatNativeDateModule),
        provideRouter(ROUTES),
        provideHttpClient(withInterceptors([relayterApiInterceptorFn])),
        provideAnimations(),
        { provide: MAT_DATE_LOCALE, useValue: navigator.language },
        { provide: MAT_DATE_FORMATS, useValue: OVERMIND_DATE_FORMATS },
        NUC_FULL_MODAL_SCROLL_STRATEGY_PROVIDER
    ]
}).catch((err) => console.error('Error bootstrapping application:', err));
